export default [
  {
    'text': '콜비 무료',
    'state': 'FREE_SERVICE_FEE'
  },
  {
    'text': '요금 할인',
    'state': 'DISCOUNT_AMOUNT'
  },
];



// WEBPACK FOOTER //
// ./src/api/couponType.js